import { render, staticRenderFns } from "./ads-postpaid-payment-method.vue?vue&type=template&id=1bf28074&scoped=true"
import script from "./ads-postpaid-payment-method.vue?vue&type=script&lang=js"
export * from "./ads-postpaid-payment-method.vue?vue&type=script&lang=js"
import style0 from "./ads-postpaid-payment-method.vue?vue&type=style&index=0&id=1bf28074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf28074",
  null
  
)

export default component.exports